import UserListingName from './UserListingName';

export default UserListingName;
